<template>
  <div class="home">
    <alternateHeader :data="getProfessionalHeader" :items="items" />
    <dayToDaySpanish :DTD="getDayToDaySpanish" />
    <trustedComaniesComponent />
    <professionalTutorial />
    <parentsSolutionComponent :data="getproSolutionsTable" />
    <partnersIndividualComponent :getTestimonials="getProTestimonials" />
    <IndividualPricingComponent />
    <professionalSocialProof :getSocialProof="getSocialProof" />
    <newsLetterComponent />
    <footerComponent />
  </div>
</template>

<script>
import alternateHeader from "@/components/alternateHeader.vue";
import trustedComaniesComponent from "@/components/trustedComaniesComponent.vue";
import partnersIndividualComponent from "@/components/partnersIndividualComponent.vue";
import dayToDaySpanish from "@/components/dayToDaySpanish.vue";
import parentsSolutionComponent from "@/components/parentsSolutionComponent.vue";
import professionalSocialProof from "@/components/professionalSocialProof.vue";
import IndividualPricingComponent from "@/components/IndividualPricingComponent.vue";
import professionalTutorial from "@/components/professionalTutorial.vue";
import newsLetterComponent from "@/components/newsLetterComponent.vue";
import footerComponent from "@/components/footerComponent.vue";
import { mapGetters, mapMutations } from "vuex";
import axios from "axios";
import { useHead } from "@unhead/vue";

export default {
  name: "professionalsComponent",
  components: {
    alternateHeader,
    dayToDaySpanish,
    trustedComaniesComponent,
    partnersIndividualComponent,
    parentsSolutionComponent,
    IndividualPricingComponent,
    professionalTutorial,
    newsLetterComponent,
    footerComponent,
    professionalSocialProof,
  },
  computed: {
    ...mapGetters([
      "getOurSolutionsIndividual",
      "getYourChallengesIndividual",
      "getCollaborationsTimelineIndividuals",
      "getProfessionalHeader",
      "getproSolutionsTable",
      "getProTestimonials",
      "getSocialProof",
      "getDayToDaySpanish",
    ]),
  },
  data() {
    return {
      items: [
        {
          title: "Home",
          disabled: false,
          href: "/",
        },
        {
          title: "For Professionals",
          disabled: false,
          href: "/for-professionals",
        },
      ],
    };
  },
  beforeMount() {
    useHead({
      title: "Comligo Spanish - Private students",
      meta: [
        {
          name: "description",
          content:
            "Comligo provides personalized Spanish language programs designed to help individuals achieve fluency, enhance cultural understanding, and expand career opportunities.",
        },
      ],
    });
  },
  mounted() {
    this.getCaseStudiesData();
    this.getCourses();
  },
  methods: {
    ...mapMutations(["setCourses", "setCaseStudies"]),
    getCourses() {
      axios
        .get(
          "https://cdn.contentful.com/spaces/8nqnktj51aoq/environments/master/entries?access_token=njkIU16uuU7MPa5hOvzUO4deV6DFYht3xdwj6KUge-k&content_type=course&limit=3&sys.id[in]=2I8yl3DHJ8A2c58kPBy9sq,5CHzIZeRg535pCStwpq29j,6VTAo5LbKkHS7fvQLAoXF7"
        )
        .then((response) => {
          this.setCourses(response.data.items);
        });
    },
    getCaseStudiesData() {
      this.loading = true;
      this.setCaseStudies([]);
      axios
        .get(
          "https://cdn.contentful.com/spaces/8nqnktj51aoq/environments/master/entries?access_token=njkIU16uuU7MPa5hOvzUO4deV6DFYht3xdwj6KUge-k&content_type=caseStudy&limit=3"
        )
        .then((response) => {
          this.loading = false;
          this.setCaseStudies(response.data.items);
          this.scrollToTop();
        });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
